import { LinearProgress } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux-latest';
import { useNavigate } from 'react-router-dom';
import { startAuthListener } from '../redux/actions';
import { AppDispatch, useAppSelector } from '../redux/store/configureStore';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { loginRequest, msalConfig } from '../authConfig';
import { red } from 'colors';

export const WaitForInitialAuthentication = ({ children }: { children?: ReactNode }) => {
    const navigate = useNavigate();
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const auth = useAppSelector((state) => state.user);
    const dispatch = useDispatch<AppDispatch>();
    const [loading, setLoading] = useState(true);
    const msal = useMsal();
    const { instance, inProgress, accounts } = useMsal();

    useEffect(() => {
        if (window.location.pathname.startsWith('/auth.html')) {
            return;
        }

        console.log('msal', msal);
        dispatch(startAuthListener(navigate, msal));

        console.log('[acquire] token silent start', inProgress, accounts);
        if (inProgress === InteractionStatus.None && accounts.length > 0) {
            const accessTokenRequest = {
                scopes: loginRequest.scopes,
                account: accounts[0],
                redirectUri: msalConfig.auth.redirectUri,
            };

            console.log('[acquire] token silent before', inProgress, accounts);

            instance
                .acquireTokenSilent(accessTokenRequest)
                .then((response) => {
                    console.log('[acquire] token silent success', response);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenPopup(accessTokenRequest).catch(function (error) {
                            console.log('[acquire] token interactive failure', error);
                        });
                    }
                    console.log('[acquire] Unknown auth error', error, error.constructor.name);
                });

            console.log('[acquire] token silent before', inProgress, accounts);
        }
    }, [instance, accounts, inProgress]);

    useEffect(() => {
        if (!auth && !auth.zaplifyUser && Object.keys(auth.zaplifyUser).length === 0) {
            return;
        }
        (async () => {
            setLoading(false);
        })();
    }, [auth.zaplifyUser]);

    return <>{children}</>;

    // return (
    //     <>
    //         {loading && <LinearProgress />}
    //         {!loading && children}
    //     </>
    // );
};
